import { CURRENT_SEARCH_ITEMS, CLEAR_TIMELINE_SEARCH_ITEMS } from "../types"

export const setCurrentSearch = (text, concepts, page) => ({
	type: CURRENT_SEARCH_ITEMS,
	payload: {
		text: text,
		concepts: concepts,
		page: page,
	},
})

export const setCurrentSearchAction = (text, concepts = [], page, filters = {}) => ({
	type: CURRENT_SEARCH_ITEMS,
	payload: {
		text: text,
		concepts: concepts,
		page: page,
		filters: filters,
	},
})

export const currentSearchActions = {
	setCurrentSearchAction,
}

export const timelineSearchItemsClear = () => ({
	type: CLEAR_TIMELINE_SEARCH_ITEMS,
})
